"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Pagination = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _lab = require("@material-ui/lab");
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Pagination = _ref => {
  let {
    boundaryCount,
    count,
    color,
    page,
    onChange,
    siblingCount,
    size
  } = _ref;
  const classes = (0, _styles.useStyles)();
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.MemoryRouter, {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, null, () => {
    return /*#__PURE__*/_react.default.createElement(_lab.Pagination, {
      boundaryCount: boundaryCount,
      color: color,
      count: count,
      onChange: onChange,
      page: page,
      renderItem: item => /*#__PURE__*/_react.default.createElement(_lab.PaginationItem, _extends({
        component: _reactRouterDom.Link,
        to: `/inbox${item.page === 1 ? '' : `?page=${item.page}`}`
      }, item, {
        variant: page === item.page ? 'text' : 'outlined'
      })),
      siblingCount: siblingCount,
      size: size
    });
  }));
};
exports.Pagination = Pagination;
Pagination.propTypes = {
  /**
   * Número de páginas visíveis no início e no final
   */
  boundaryCount: _propTypes.default.number,
  /**
   * Número de páginas que sera exibida no componente
   */
  count: _propTypes.default.number.isRequired,
  /**
   * Cor dos botões de paginação
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']).isRequired,
  /**
   * Retorno de chamada disparado quando a página é alterada
   */
  onChange: _propTypes.default.func,
  /**
   * Número de páginas visíveis antes e depois da página atual
   */
  siblingCount: _propTypes.default.number,
  /**
   * Tamanho do componente
   */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  /**
   * Página atual
   */
  page: _propTypes.default.number
};
Pagination.defaultProps = {
  boundaryCount: 1,
  onChange: null,
  siblingCount: 1,
  size: 'medium',
  page: 1
};
var _default = exports.default = Pagination;